import React, { useRef, useState } from "react";
import { Tooltip } from "@fluentui/react-components";

/**
 * Text that is cut short with an ellipsis by the style it is given, which shows all of it in a tooltip, and only
 * when it really was cut.
 *
 * @param className  the style that cuts the text short; it must make this element hold the text on a single line
 */
export default function TruncatedText({ text, className }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  return (
    <Tooltip
      content={text}
      relationship="description"
      positioning="above-start"
      visible={visible}
      onVisibleChange={(_, data) => setVisible(Boolean(data.visible) && Boolean(ref.current) && ref.current.scrollWidth > ref.current.clientWidth)}
    >
      <span ref={ref} className={className} style={{ display: "inline-block", maxWidth: "100%", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "bottom" }}>
        {text}
      </span>
    </Tooltip>
  );
}
